import { posToDOMRect } from '@tiptap/core';
import { Editor, isNodeSelection } from '@tiptap/core';

export const getCoordinatesFromSelection = (
  editor: Editor,
  atStart: boolean = true,
): DOMRect => {
  const { ranges } = editor.state.selection;
  const from = Math.min(...ranges.map((range) => range.$from.pos));
  const to = Math.max(...ranges.map((range) => range.$to.pos));

  if (isNodeSelection(editor.state.selection)) {
    let node = editor.view.nodeDOM(atStart ? from : to) as HTMLElement;

    if (node) {
      const nodeViewWrapper = node.dataset.nodeViewWrapper
        ? node
        : node.querySelector('[data-node-view-wrapper]');

      if (nodeViewWrapper) {
        node = nodeViewWrapper.firstChild as HTMLElement;
      }

      if (node) {
        return node.getBoundingClientRect();
      }
    }
  }

  return posToDOMRect(editor.view, atStart ? from : to, atStart ? from : to);
};

export const getTableToolbarCoordinates = (editor: Editor): DOMRect => {
  // Use the current cursor position to position the toolbar
  // This makes it follow the user's clicks within the table
  return getCoordinatesFromSelection(editor, true);
};
